import React, { useEffect, useRef } from "react";
import { Brain } from "lucide-react";
import "./Heroo.css";
import cube from "../../assets/hr-bg.png"
import AiStackSection from "../AiStackSection";
import AiStack from "../Aistack";

// ── DigitalCore data ──────────────────────────────────────────────────────────


// ── Hero Component ────────────────────────────────────────────────────────────

const Heroo = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };

    resize();
    window.addEventListener("resize", resize);

    const particles = Array.from({ length: 150 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      r: Math.random() * 2.5 + 0.5,
      dx: (Math.random() - 0.5) * 0.5,
      dy: (Math.random() - 0.5) * 0.5,
      opacity: Math.random() * 0.6 + 0.2,
      sparkle: Math.random() * Math.PI * 2,
    }));

    let animationId;

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((a, i) => {
        particles.slice(i + 1).forEach((b) => {
          const dist = Math.hypot(a.x - b.x, a.y - b.y);
          if (dist < 120) {
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            const opacity = 0.12 * (1 - dist / 120);
            const gradient = ctx.createLinearGradient(a.x, a.y, b.x, b.y);
            gradient.addColorStop(0, `rgba(194, 161, 90, ${opacity})`);
            gradient.addColorStop(1, `rgba(199, 157, 90, ${opacity * 0.5})`);
            ctx.strokeStyle = gradient;
            ctx.lineWidth = 0.6;
            ctx.stroke();
          }
        });
      });

      particles.forEach((p) => {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        const gradient = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
        gradient.addColorStop(0, `rgba(255, 215, 120, ${p.opacity})`);
        gradient.addColorStop(0.5, `rgba(199, 157, 90, ${p.opacity * 0.7})`);
        gradient.addColorStop(1, `rgba(199, 157, 90, ${p.opacity * 0.3})`);
        ctx.fillStyle = gradient;
        ctx.fill();

        ctx.save();
        ctx.shadowBlur = 8;
        ctx.shadowColor = `rgba(194, 161, 90, ${p.opacity * 0.8})`;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * 0.5, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 235, 160, ${p.opacity * 0.9})`;
        ctx.fill();

        if (p.r > 1.5) {
          ctx.beginPath();
          ctx.moveTo(p.x - p.r * 1.2, p.y);
          ctx.lineTo(p.x + p.r * 1.2, p.y);
          ctx.moveTo(p.x, p.y - p.r * 1.2);
          ctx.lineTo(p.x, p.y + p.r * 1.2);
          ctx.strokeStyle = `rgba(255, 215, 120, ${p.opacity * 0.6})`;
          ctx.lineWidth = 0.8;
          ctx.stroke();
        }
        ctx.restore();

        p.x += p.dx;
        p.y += p.dy;
        p.sparkle += 0.05;

        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;
      });

      animationId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <section className="hero">
      <canvas ref={canvasRef} className="hero__canvas" />

      <div className="hero__content">
        {/* ── LEFT: text ── */}
        <div className="hero__main">
          <div className="hero__badge">
            <span className="hero__badge-text">Transformation Engineered</span>
          </div>

          <h1 className="hero__title">
            We architect transformation

            {/* <br /> */}
            <br />
            that <span className="hero__highlight">scales, adapts</span>
            <br />
            <span className="hero__highlight">and lasts.</span>
          </h1>

          <p className="hero__description">
            We don't advise on transformation. We architect it—end to end—aligning strategy, technology,
            people and operations to create compounding value.
          </p>

          <div className="hero__cta-group">
            <a href="/contact">
              <button className="hero__cta-button hero__cta-primary">
                Start a Conversation
                <svg className="hero__cta-arrow" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M3.75 9H14.25M14.25 9L10.5 5.25M14.25 9L10.5 12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </a>

            <a href="/thinking/blogs">
              <button className="hero__cta-button hero__cta-secondary">
                Explore Our Thinking
                <svg className="hero__cta-arrow" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M3.75 9H14.25M14.25 9L10.5 5.25M14.25 9L10.5 12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </a>

          </div>
        </div>

        <img src={cube} alt="" className="hero-right-img" />
        {/* <div className="hro-right"> */}
        {/* <AiStackSection /> */}
        {/* <AiStack /> */}
        {/* </div> */}
      </div>
    </section>
  );
};

export default Heroo;